import { useQuery } from "react-query";
import { stringifyUrl } from "query-string";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useReportUninvoiced = (params, config) => {
  return useQuery({
    ...config,
    queryKey: ["uninvoiced-report", params],
    queryFn: ({ signal }) =>
      fetch({
        url: stringifyUrl(
          {
            url: `${Angie.api_url}/reports/uninvoiced`,
            query: { status: params?.status, budget_type: params?.budget_type },
          },
          { arrayFormat: "bracket" }
        ),
        signal,
      }),
  });
};
